import { ElementRef } from '@angular/core';
import { WatchlistsService } from 'WatchlistApp/ts/services/watchlists.service';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "WatchlistApp/ts/services/watchlists.service";
import * as i2 from "../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
/**
 *
 * SaveAsWatchlistButton.
 *
 * Required Attributes:
 *      @ securityIDs:   list of security IDs in the watch list
 *      @ watchlistName: watch list name
 *      @ watchlistType: watch list type, one of WatchlistType.
 */
export class SaveAsWatchlistButton {
    constructor(eltRef, watchlistsService) {
        this.eltRef = eltRef;
        this.watchlistsService = watchlistsService;
        this.saveAsWatchlistResult = '';
        this.securityIds = JSON.parse(this.eltRef.nativeElement.getAttribute('securityIds'));
        this.watchlistName = this.eltRef.nativeElement.getAttribute('watchlistName');
        this.watchlistType = this.eltRef.nativeElement.getAttribute('watchlistType');
    }
    save() {
        if (this.watchlistType === '') {
            const errorMessage = 'Securities in list include securities that can not be saved in a single watchlist';
            this.saveAsWatchlistResult = errorMessage;
            this.confirmModal.openModal();
        }
        else {
            this.watchlistsService
                .postWatchlist(this.watchlistType, this.watchlistName, this.securityIds)
                .subscribe({
                next: () => {
                    const successMessage = `Successfully created Watchlist "${this.watchlistName}"`;
                    this.saveAsWatchlistResult = successMessage;
                    this.confirmModal.openModal();
                },
                error: () => {
                    const errorMessage = 'An error occurred. Please try again or contact us with details of your problem.';
                    this.saveAsWatchlistResult = errorMessage;
                    this.confirmModal.openModal();
                },
            });
        }
    }
}
SaveAsWatchlistButton.ɵfac = function SaveAsWatchlistButton_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SaveAsWatchlistButton)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.WatchlistsService)); };
SaveAsWatchlistButton.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SaveAsWatchlistButton, selectors: [["ycn-save-as-watchlist-button"]], viewQuery: function SaveAsWatchlistButton_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(ConfirmModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.confirmModal = _t.first);
    } }, standalone: false, decls: 3, vars: 4, consts: [[1, "btn", "btn-secondary", 3, "click"], [3, "confirmHeader", "confirmText", "cancelButtonText", "showConfirmButton"]], template: function SaveAsWatchlistButton_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵlistener("click", function SaveAsWatchlistButton_Template_div_click_0_listener() { return ctx.save(); });
        i0.ɵɵtext(1, " Save as Watchlist\n");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(2, "ycn-confirm-modal", 1);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmHeader", "Save as Watchlist")("confirmText", ctx.saveAsWatchlistResult)("cancelButtonText", "Close")("showConfirmButton", false);
    } }, dependencies: [i2.ConfirmModalComponent], encapsulation: 2 });
